
// vue
import { defineComponent } from 'vue';

// components
import DesktopView  from './ui/desktop-view.vue';
import MobileView   from './ui/mobile-view.vue';

// store
import { useGl } from '@/store/gl';
// import { useProfileStore } from '@/store/profile';

export default defineComponent({
    name: 'rb-reset-fix-order',
    components: {
        DesktopView,
        MobileView,
    },
    setup() {
        // store
        const gl   = useGl();
        // const profileStore = useProfileStore();

        return {
            gl,
        };
    },
});
